import { PromotionService } from './../../../../../services/promotion.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { DatePipe, Location } from '@angular/common';
import { Router } from '@angular/router';
import { IPromotion, Promotion } from '../../../../../models/promotion.model';
import { PromotionItemService } from '../../../../../services/promotionItem.service';
import { IPromotionItem, PromotionItem } from '../../../../../models/promotionItem.model';
import { TypeOfferService } from '../../../../../services/typeOffer.service';
import { ITypeOffer, TypeOffer } from '../../../../../models/typeOffer.model';
import { NameValidator } from '../../../validators/name.validator';
import { PostPromotion } from '../../../../../models/postPromotion.model';
import { PostPromotionService } from '../../../../../services/postPromotion.service';
import { CustomValidators } from '../../../../customValidators';
import { environment } from '../../../../../environments/environment';
import { ProductService } from '../../../../../services/product.service';
import { PaginationService } from '../../../../../services/pagination.service';
@Component({
  selector: 'app-promotion-offer-active',
  templateUrl: './promotion-offer-active.component.html',
  styleUrls: ['./promotion-offer-active.component.scss']
})
export class PromotionOfferActiveComponent implements OnInit {

  @ViewChild('closebutton1') closebutton1;
  x_article_achete_y_article_offert = false;
  x_pourcent_de_reduction  = false;
  livraison_gratuite = false;
  frais_de_deplacement_gratuite = false;
  reduction_de_x_montant_sur_les_frais_de_deplacement = false;
  livraison_gratuite_x_montant = false;
  x_montant_reduit_sur_la_livraison_des_articles = false;
  x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
  search: any;
  allPromotions: PostPromotion[] = [];
  allPromotionsTmp: PostPromotion[] = [];
  // @ts-ignore
  currentPromotion: IPromotion = [];
  pageNumber: number = 1;
  pageSize: number = 15;
  totalItems: number;
  sorted = false;
  sorted1 = false;
  sorted01 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  isTrueName = false;
  offertypes: ITypeOffer[] = [];
  @ViewChild('closebutton') closebutton;
  url_photo: String;
  constructor(private fb: FormBuilder, private promotionService: PromotionService ,
              private router :Router, private productService : ProductService,
              private promotionItemService: PromotionItemService,private datePipe: DatePipe,
              private typeOfferService : TypeOfferService, private postPromotionService: PostPromotionService,
              private location: Location,private paginationService: PaginationService) { }

  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    this.loadPromotions();
    this.loadOfferTypes();
  }

  goBack(): void {
    this.location.back();
  }

  model = {
    description: ''
  };

  promotionForm = this.fb.group({
    promotionForm0: this.fb.group({
      name : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    promotionForm1: this.fb.group({
      typeOffer : new FormControl("" , [Validators.required]),
    }),
     // x-pourcent-de-reduction
    promotionForm2: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
    }),
    // Livraison-gratuite-x-montant
    promotionForm3: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
    }),
    // x-montant-reduit-sur-la-livraison-des-articles
    promotionForm4: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
    }),
    // x-article-achete-y-article-offert
    promotionForm5: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
    }),
    // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
    promotionForm6: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
      param2 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
    }),

    promotionForm7: this.fb.group({
      description : new FormControl("" , [Validators.required]),
    }),
  });

  get testName() {return this.promotionForm.get('promotionForm0.name');}
  get testTypeOffer() {return this.promotionForm.get('promotionForm1.typeOffer');}
  // x-pourcent-de-reduction
  get testParam0Form2() {return this.promotionForm.get('promotionForm2.param0');}
  // Livraison-gratuite-x-montant
  get testParam0Form3() {return this.promotionForm.get('promotionForm3.param0');}
  // x-montant-reduit-sur-la-livraison-des-articles
  get testParam0Form4() {return this.promotionForm.get('promotionForm4.param0');}
  // x-article-achete-y-article-offert
  get testParam0Form5() {return this.promotionForm.get('promotionForm5.param0');}
  get testParam1Form5() {return this.promotionForm.get('promotionForm5.param1');}
  // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
  get testParam0Form6() {return this.promotionForm.get('promotionForm6.param0');}
  get testParam1Form6() {return this.promotionForm.get('promotionForm6.param1');}
  get testParam2Form6() {return this.promotionForm.get('promotionForm6.param2');}

  get testdescriptionForm7() {return this.promotionForm.get('promotionForm7.description');}

  loadOfferTypes(){
    this.typeOfferService.getTypeOffers().subscribe(rs=>{
      this.offertypes = rs;
      // console.log(this.offertypes)
    });
  }

  enablePostPromotion(prost:PostPromotion){
    Swal.fire({
      title: 'Voulez-vous activer cette promotion ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromotionService.enablePostPromotion(prost?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Votre promotion a été activée avec succés.',
              showConfirmButton: false,
              timer: 3000
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
          }
        )
      }
    })
  }

  disablePostPromotion(prost:PostPromotion){
    Swal.fire({
      title: 'Désactiver cette promotion.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromotionService.disablePostPromotion(prost?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Votre promotion a été désactivée avec succés.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
        })
      }
    })
  }

  selectedOfferType : TypeOffer;
  selectedOfferTypeSlug : any;
  getOfferTypeById(id: any){
    this.typeOfferService.getIdTypeOffer(Number(id)).subscribe(rs=>{
      this.selectedOfferType = rs;
      // console.log("Type d'offre.........");
      // console.log(this.selectedOfferType);
      if(this.selectedOfferType != null && this.selectedOfferType !=undefined){
        this.selectedOfferTypeSlug = this.selectedOfferType?.slug;
        if(this.selectedOfferTypeSlug === "livraison-gratuite"){
          this.livraison_gratuite = true;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuite = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
        }else if(this.selectedOfferTypeSlug === "x-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction  = true;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuite = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
        }else if(this.selectedOfferTypeSlug === "livraison-gratuite-a-partir-dun-x-montant-dachat"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction  = false;
          this.livraison_gratuite_x_montant = true;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuite = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
        }else if(this.selectedOfferTypeSlug === "x-montant-reduit-sur-la-livraison-des-articles"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = true;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuite = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
        }else if(this.selectedOfferTypeSlug === "x-produit-achete-n-ieme-a-y-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = true;
          this.frais_de_deplacement_gratuite = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
        }else if(this.selectedOfferTypeSlug === "x-article-achete-y-article-offert"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = true;
          this.x_pourcent_de_reduction  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuite = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
        }else if(this.selectedOfferTypeSlug === "frais-de-deplacement-gratuite"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuite = true;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
        }else if(this.selectedOfferTypeSlug === "reduction-de-x-montant-sur-les-frais-de-deplacement"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuite = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = true;
        }
      }
    });
  }

  get getPost() { return this.postPromotionForm.controls; }

  postPromotionForm = this.fb.group({
    startDate : new FormControl("" , [Validators.required, CustomValidators.startDateNotBeforeToday]),
    endDate : new FormControl("" , [Validators.required]),
  });

  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  startDateNotBeforeDateNow = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;
  getSelectedDate() {
    this.selectedStartDate = this.postPromotionForm.get('startDate')?.value;
    this.selectedEndDate = this.postPromotionForm.get('endDate')?.value;
    if(this.selectedStartDate > this.selectedEndDate){
      this.startDateNotAfterEndDate = true;
    }else{
      this.startDateNotAfterEndDate = false;
    }
    // console.log("this.startDateNotAfterEndDate = true;", this.startDateNotAfterEndDate)
  }

  getSelectedEndDate() {
    const startDateString = this.postPromotionForm.get('startDate')?.value;
    const endDateString = this.postPromotionForm.get('endDate')?.value;

    // Conversion des chaînes en objets Date
    this.selectedStartDate = new Date(startDateString);
    this.selectedEndDate = new Date(endDateString);

    if (this.selectedStartDate > this.selectedEndDate) {
      this.startDateNotAfterEndDate = true;
    } else {
      this.startDateNotAfterEndDate = false;
    }

    if (this.selectedStartDate.getTime() === this.selectedEndDate.getTime()) {
      this.startDateNotEqualsEndDate = true;
    } else {
      this.startDateNotEqualsEndDate = false;
    }

    const oneHourInMilliseconds = 60 * 60 * 1000;

    if (this.selectedEndDate.getTime() - this.selectedStartDate.getTime() < oneHourInMilliseconds) {
      this.endDateNotAfterStartDate = true;
    } else {
      this.endDateNotAfterStartDate = false;
    }
  }

  selectedPromotion: Promotion;
  getPromotion(promo: any){
    this.promotionService.getIdPromotion(promo.id).subscribe(rs =>{
      this.selectedPromotion = rs;
      if(this.selectedPromotion != undefined && this.selectedPromotion.promotionItem){
        this.getOfferTypeById(this.selectedPromotion?.promotionItem[0]?.typeOffer?.id);
      }
    })
  }

  onViewPromo(promoid: any) {
    this.postPromotionService.getIdPostPromotion(promoid.id).subscribe(rs=>{
      this.currentPromotion = rs;
      // console.log(this.currentPromotion);
    })
  }

  isoequalstoname = false;
  verifyPromotionName(){
    return null;
  }


  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  x_article_achete_y_article_offert1 = "x-article-achete-y-article-offert";
  x_pourcent_de_reduction1  = "x-pourcent-de-reduction";
  livraison_gratuite1 = "livraison-gratuite";
  livraison_gratuite_x_montant1 = "livraison-gratuite-a-partir-dun-x-montant-dachat";
  x_montant_reduit_sur_la_livraison_des_articles1 = "x-montant-reduit-sur-la-livraison-des-articles";
  x_produit_achete_n_ieme_a_y_pourcent_de_reduction1 = "x-produit-achete-n-ieme-a-y-pourcent-de-reduction";

  updatedPostPromotion : PostPromotion;
  onEditPromotion(promo: any) {
    this.updatedPostPromotion = promo;
    this.postPromotionForm = this.fb.group({
      startDate : new FormControl(this.updatedPostPromotion.startDate , [Validators.required, NameValidator.startDateNotBeforeToday]),
      endDate : new FormControl(this.updatedPostPromotion.endDate , [Validators.required]),
    });
  }

  loadPromotions() {
    this.promotionService.getKahpooSellerPromotions(this.pageNumber - 1, this.pageSize).subscribe((data: any) => {
      this.allPromotions = data.content;
     // this.allPromotionsTmp = data.content;
      this.totalItems = data.totalElements;
      this.allPromotions = this.getProductShopName(this.allPromotions)
    //  console.log("Liste des promotions des vendeurs###...###");
    //  console.log(this.allPromotions);
      }, (err) => {
        // console.log('-----> err', err);
    });
  }

  perPage = 10;
  displayPerPage(itemsPerPage: any) {
    this.pageSize = itemsPerPage;
    this.loadPromotions();
  }

  getProductShopName(products: any[]): any[] {

    products.forEach(element => {
      if(element?.post?.postSubProducts[0]){
        this.productService.getProductbyProductId(element?.post?.postSubProducts[0]?.subProduct?.productID).subscribe(rs=>{
          element.shopName = rs?.shop?.name;
          element.price = element?.post?.postSubProducts[0]?.finalPrice;
          element.reference = element?.post?.postSubProducts[0]?.subProduct?.subProductID;
        })
      }else if(element?.post?.postServiceModels[0]){
        element.shopName = element?.post?.postServiceModels[0]?.serviceModel?.shop?.name;
        element.price = element?.post?.postServiceModels[0]?.finalPrice;
        element.reference = element?.post?.postServiceModels[0]?.serviceID;
      }
    })
    return products;
  }

  onEditPromotionFormSubmit(){
    if(this.promotionForm.controls.promotionForm0.invalid){
      this.promotionForm.controls.promotionForm0.markAllAsTouched();
      this.promotionForm.controls.promotionForm1.markAsUntouched();
      this.promotionForm.controls.promotionForm2.markAsUntouched();
      this.promotionForm.controls.promotionForm3.markAsUntouched();
      this.promotionForm.controls.promotionForm4.markAsUntouched();
      this.promotionForm.controls.promotionForm5.markAsUntouched();
      this.promotionForm.controls.promotionForm6.markAsUntouched();
      this.promotionForm.controls.promotionForm7.markAsUntouched();
      return;
    }
    if(this.promotionForm.controls.promotionForm0.valid &&
      this.promotionForm.controls.promotionForm1.valid  &&
      this.promotionForm.controls.promotionForm7.valid  &&
      this.livraison_gratuite){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionForm.controls['promotionForm0'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;
      promotionItem.typeOffer = this.selectedOfferType;
      updatedPromotion.promotionItem = promotionItems;
      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;

      promotionItem.name = form.name+" "+"livraison gratuite";
      promotionItems.push(promotionItem);
      // console.log("Promo modifiée avec livraison gratuite...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès..',
          showConfirmButton: false,
          timer: 1500
        });
        this.close1();

        this.reloadComponent();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm2.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_pourcent_de_reduction){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();
      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm2'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;

      promotionItem.name = form.name+" "+" réduction de "+form2.param0 +"%";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);
      updatedPromotion.promotionItem = promotionItems;
      // console.log("Promo modifiée avec x_pourcent_de_reduction...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès..',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm3.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.livraison_gratuite_x_montant){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm3'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;

      promotionItem.name = form.name+" "+" livraison gratuite à partir de "+form2.param0 +" FCFA acheté.";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      // console.log("Promo Modifié avec livraison_gratuite_x_montant...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm4.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_montant_reduit_sur_la_livraison_des_articles){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm4'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;

      promotionItem.name = form.name+" "+form2.param0 +" FCFA réduit sur la livraison des articles.";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      // console.log("Promo modifiée avec x_montant_reduit_sur_la_livraison_des_articles...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm5.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_article_achete_y_article_offert){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm5'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;

      promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s)"+form2.param1+" articles(s) offert(s)";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItem.value1 = form2.param1;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      // console.log("Promo modifiée avec x_article_achete_y_article_offert...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm6.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm6'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;

      promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s) et le "+form2.param1+" articles(s) à "+form2.param2+"% de réduction";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItem.value1 = form2.param1;
      promotionItem.value2 = form2.param2;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      // console.log("Promo modifiée avec x_produit_achete_n_ieme_a_y_pourcent_de_reduction...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid  &&
             this.promotionForm.controls.promotionForm7.valid  &&
             this.frais_de_deplacement_gratuite){
        let updatedPromotion = this.currentPromotion;
        let promotionItems: PromotionItem[] = [];
        let promotionItem = new PromotionItem();

        let form = this.promotionForm.controls['promotionForm0'].value;
        let form7 = this.promotionForm.controls['promotionForm7'].value;
        promotionItem.typeOffer = this.selectedOfferType;
        updatedPromotion.promotionItem = promotionItems;
        updatedPromotion.name = form.name;
        updatedPromotion.description = form7.description;

        promotionItem.name = form.name+" "+"frais de déplacement gratuite";
        promotionItems.push(promotionItem);
        // console.log("Promo modifiée avec frais de déplacement gratuite...");
        // console.log(updatedPromotion);
        this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La promotion a été modifiée avec succès..',
            showConfirmButton: false,
            timer: 1500
          });
          this.close1();

          this.reloadComponent();
        }, error => {
          // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 1500
          });
        });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm4.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.reduction_de_x_montant_sur_les_frais_de_deplacement){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm4'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;

      promotionItem.name = form.name+"Réduction de "+form2.param0 +" FCFA sur les frais de déplacement.";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      // console.log("Promo modifiée avec reduction_de_x_montant_sur_les_frais_de_deplacement...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }
  // Récupération de la date de fin

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadPromotions();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }


  onPostPromotionFormSubmit(): void {
    let postPromo = new PostPromotion();
    const startDate = this.postPromotionForm.controls['startDate'].value;
    const endDate = this.postPromotionForm.controls['endDate'].value;
    // console.log(startDate);
    // console.log(endDate);
    if(!this.startDateNotBeforeDateNow && !this.startDateNotAfterEndDate){
      postPromo.id = this.updatedPostPromotion.id;
      postPromo.startDate = startDate;
      postPromo.endDate = endDate;
      // console.log("Updeted post promotion...");
      // console.log(postPromo);
      
      this.postPromotionService.updtatePostPromotion(postPromo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Votre promotion a été modifiée avec succés.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        //console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 4500
        });
      });
    }

  }

  dateForm = this.fb.group({
    beginDate: new FormControl('', [Validators.required]),
    endDate: new FormControl('', [Validators.required])
  })

  filterByDate() {
    if(this.dateForm.get('beginDate').invalid || this.dateForm.get('endDate').invalid){
      
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veuillez renseigner la date de début et la date de fin',
          showConfirmButton: false,
          timer: 3500
        });
        return;
      
    }
    const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    // console.log("Date sélectionnée")
    // console.log('beginDate:', beginDate);
    // console.log('endDate:', endDate);
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      if (beginDate === endDate) {
        this.allPromotions = this.allPromotions.filter(p => {
          // Conversion des dates en objets Date
          const startDate = new Date(p.startDate);
          const endDate = new Date(p.endDate);
      
          // Comparaison uniquement des parties jour/mois/année sans l'heure
          return (
            startDate.getFullYear() === endDate.getFullYear() &&
            startDate.getMonth() === endDate.getMonth() &&
            startDate.getDate() === endDate.getDate()
          );
        });
      }else{
        this.promotionService.getKahpooSellerPromotionsFilter(beginDate, endDate,this.pageNumber - 1, this.pageSize).subscribe(data =>{
          this.allPromotions = data.content;
          this.allPromotionsTmp = data.content;
          this.totalItems = data.totalElements;
          this.allPromotions = this.getProductShopName(this.allPromotions)
          //console.log("Liste des promotions des vendeurs...###");
          //console.log(data.content);
        });
      }
     
    }

    // const beginDate1 = new Date(beginDate);
    // const endDate1 = new Date(endDate);
    // this.allPromotions = this.allPromotionsTmp.filter((promo) => {
    //   const itemStartDate = new Date(promo.startDate);
    //   const itemEndDate = new Date(promo.endDate);

    //   console.log('itemStartDate:', itemStartDate);
    //   console.log('itemEndDate:', itemEndDate);

    //   const result = (
    //     (beginDate1 <= itemEndDate && endDate1 >= itemStartDate) ||
    //     (!beginDate1 && endDate1 >= itemStartDate) ||
    //     (!endDate1 && beginDate1 <= itemEndDate)
    //   );

    //   console.log('result:', result);

    //   return result;
    // });

    // console.log('Filtered Promotions:', this.allPromotions);
  }



  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  searchFilter($event: KeyboardEvent) {
    //this.pageSize = 5000
    this.promotionService.getKahpooSellerPromotions(0, 5000).subscribe((data: any) => {
      this.allPromotionsTmp = data.content;
      this.totalItems = data.totalElements;
      // console.log("Liste des allPromotionsTmp des vendeurs###...###");
      // console.log(this.allPromotionsTmp);
      }, (err) => {
        // console.log('-----> err', err);
    });
    let param = this.search.toLowerCase()
    this.allPromotions =  this.allPromotionsTmp.filter(
      value => 
      value.post?.title.toLowerCase().includes(param) ||
      value.shopName?.toLowerCase().includes(param) ||
      value.reference?.toString().includes(param) ||
      value.startDate?.toString().includes(param) ||
      value.endDate?.toString().includes(param) ||
      value.post?.title?.toString().includes(param) ||
      value?.promotion?.promotionItem[0]?.name.toLowerCase().includes(param)
    );
    // console.log("this.search.toLowerCase()", this.search.toLowerCase())
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  deletePromotion(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez vous vraiment supprimer cette promotion ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.postPromotionService.disablePostPromotion(id).subscribe(
          rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La promotion a été supprimé avec succés',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadPromotions();
        },error =>{
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 4500
          });
        });
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    })
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.post?.title > b.post?.title ? 1 : a.post?.title < b.post?.title ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.post?.title < b.post?.title ? 1 : a.post?.title > b.post?.title ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort01() {
    if(this.sorted01 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.reference > b.reference ? 1 : a.reference < b.reference ? -1 : 0)
      this.sorted01 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.reference < b.reference ? 1 : a.reference > b.reference ? -1 : 0)
      this.sorted01 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.price > b.price ? 1 : a.price < b.price ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.price < b.price ? 1 : a.price > b.price ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.shopName > b.shopName ? 1 : a.shopName < b.shopName ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.shopName < b.shopName ? 1 : a.shopName > b.shopName ? -1 : 0)
      this.sorted3 = false;
    }
  }

  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.startDate > b.startDate ? 1 : a.startDate < b.startDate ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.startDate < b.startDate ? 1 : a.startDate > b.startDate ? -1 : 0)
      this.sorted4 = false;
    }
  }

  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.endDate > b.endDate ? 1 : a.endDate < b.endDate ? -1 : 0)
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.endDate < b.endDate ? 1 : a.endDate > b.endDate ? -1 : 0)
      this.sorted5 = false;
    }
  }

  sort6() {
    if(this.sorted6 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a?.promotion?.promotionItem[0]?.name > b?.promotion?.promotionItem[0]?.name ? 1 : a?.promotion?.promotionItem[0]?.name < b?.promotion?.promotionItem[0]?.name ? -1 : 0)
      this.sorted6 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a?.promotion?.promotionItem[0]?.name < b?.promotion?.promotionItem[0]?.name ? 1 : a?.promotion?.promotionItem[0]?.name > b?.promotion?.promotionItem[0]?.name ? -1 : 0)
      this.sorted6 = false;
    }
  }

  strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}

  strUcFirst1(valeur: any) {
    if (valeur != undefined && valeur?.promotion?.promotionItem?.[0]?.typeOffer?.name) {
      return valeur?.promotion?.promotionItem[0].typeOffer.name;
    } else {
      // Gérer le cas où l'une des propriétés est undefined
      return "La propriété est indéfinie ou n'a pas la structure attendue";
    }
  }

  minDate(): string {
    const today = new Date();
    return today.toISOString().slice(0, 16); // Format ISO pour la date et l'heure.
  }

  strUcFirst2(valeur : any){
    if(valeur != undefined && valeur?.promotionItem?.[0]?.typeOffer?.slug){
      return valeur?.promotionItem[0]?.typeOffer?.slug;
    }
  }

  strUcFirst22(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value0
    }
  }

  strUcFirst33(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value1
    }
  }

  strUcFirst44(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value2
    }
  }


  strUcFirst3(valeur : any){
    if(valeur != undefined && valeur?.promotionItem?.[0]?.typeOffer){
      return valeur?.promotionItem[0]?.typeOffer;
    }
  }

  getPhotoService(postProd : any){
    return postProd?.post?.postServiceModels[0]?.photo;
  }

  getPhotoProduit(postProd : any){
    return postProd?.post?.postSubProducts[0]?.photo;
  }
  getPostProdName(postProd : any){
    return postProd?.post?.postSubProducts[0]?.subProduct?.name;
  }
  getPostSevName(postProd : any){
    return postProd?.post?.postServiceModels[0]?.name;
  }

  getPostShopName(postProd : any){
    return postProd?.post?.postServiceModels[0]?.name;
  }


}
